// extracted by mini-css-extract-plugin
export default {"Card":"styles_Card__7xrBf","Bio":"styles_Bio__nTKqH"};